<template>
  <v-row class="pa-0">
    <v-col cols="12" xs="12">
      <TablePlayList ref="table" :showTitle="false" :companyId="companyId" :isCompanyView="true" :show-expand="true" :allowSharing="formData !== null && formData.typ === 1"/>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-row align="start">
        <v-col cols="12" md="3" xs="12" align="start" v-if="formData !== null && formData.typ === 0">
          <v-btn color="primary"  @click="shareChannels()">Kanäle verteilen</v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" md="3" xs="12" align="start">
          <v-btn color="primary" @click="createItem()">Neu erstellen</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <DialogLinkChannels ref="dlgShare" :removeVeranstalter='true' @save="onShareChannels" @remove="onRemoveChannels"></DialogLinkChannels>
  </v-row>
</template>

<script>
import Vue from 'vue'
import TablePlayList from "../../tables/TablePlaylist"
import DialogLinkChannels from "./../dialogs/DialogLinkChannels"
var _ = require('lodash')

export default {
  name: 'TabPlaylist',
  components: {TablePlayList, DialogLinkChannels},
  props: {
    formData: Object,
    companyId: String
  },
  methods: {
    open: function () {
      this.opened = true
      this.$refs.table.reload()
    },
    shareChannels: function () {
      this.$refs.dlgShare.open({}, this.companyId)
    },
    onShareChannels: function (data) {
      console.log('onShareChannels', data)
      var xData = data
      _.forEach(xData.playlists, function (pl) {
        console.log('pl', pl.guid)
        _.forEach(xData.locations, function (loc) {
          console.log('loc', loc.guid)
          Vue.prototype.$api.createCloneLinkPlayListToCompany(pl, loc, function (data) {
            console.log('link done', data)
          })
        })
      })
    },
    onRemoveChannels: function (data) {
      console.log('onRemoveChannels', data)
      var xData = data
      _.forEach(xData.playlists, function (pl) {
        _.forEach(xData.locations, function (loc) {
          Vue.prototype.$api.removeCloneLinkPlayListToCompany(pl.guid, loc.guid, function (data) {
            console.log('unlink done', data)
          })
        })
      })
    },
    createItem: function () {
      console.log('createItem')
      let isVeranstalter = this.formData !== null && this.formData.typ === 1
      let channel = 0
      if (isVeranstalter) {
        channel = 20
      }
      Vue.prototype.$api.createPlaylist({
        guidCompany: this.companyId,
        channel: channel
      }, this.onPlayListCreated)
    },
    onPlayListCreated: function (newItem) {
      console.log('onPlayListCreated', newItem)
      this.$router.push('/Netzwerke/' + this.companyId + '/Playlist/' + newItem.guid)
    }
  },
  data () {
    return {
      opened: false
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
